import { FovImage } from 'composables/Product/VideoRoiCalculator/videoRoiCalculatorTypes';

export const FOV_IMAGES: FovImage[] = [
  { fov: 72, id: '67B0E8CDB0BF44F58BE3BCC4C087D77F' },
  { fov: 110, id: '8DB22FC2DFEA4B66B4BE35B963C2B11F' },
  { fov: 180, id: '09C3323A017B4FDA946C4226BD03AAA3' },
];
